import React, {HTMLInputTypeAttribute} from 'react';
import {Field, FieldError, FieldLabel} from "@root/server/client/esweb/components/ui/field";
import {Input} from "@root/server/client/esweb/components/ui/input";
import {Control, Controller, FieldPath} from "react-hook-form";

let ix = 0;

export function RhfInput<FORM_TYPE>(params: {
    name: FieldPath<FORM_TYPE>
    label?: string,
    nullable?: boolean,
    type?: string,
    control: Control<FORM_TYPE>,
    inputProps: Record<string, unknown>,
    className?: string
}) {
    const id = `finput-${ix++}`;

    const {
        name,
        label,
        control,
        type,
        nullable = false,
        inputProps,
        className
    } = params;


    function convertType(str: string): unknown {
        if (str === '' && nullable) {
            return null;
        }

        if (type === 'number') {
            return str === '' ? null : parseInt(str);
        }

        return str;
    }

    return <Controller
        {...{name, control}}
        render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid} {...{className}}>
                {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
                <Input
                    {...field as {}}
                    onChange={e => field.onChange(convertType(e.target.value, ))}
                    id={id}
                    aria-invalid={fieldState.invalid}
                    autoComplete="off"
                    {...{type}}
                    {...inputProps}
                />
                {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                )}
            </Field>
        )}
    />
}


